export const PAGE_TITLE = 'Listings';